import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesCargoIdDetailMain } from './modules/ui/Main';

const CargoIdDetailPage = (
  <SuspensePage>
    <PagesCargoIdDetailMain />
  </SuspensePage>
);

export default CargoIdDetailPage;
